/*global $ */
import "slick-carousel";

class Hero {
  constructor() {
    console.log("Hero");

    var $slide = $(".top_visual_slider")
      .slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        speed: 2000,
        autoplaySpeed: 6000,
        autoplay: true,
        pauseOnHover: false,
      })
      .on({
        beforeChange: (event, slick, currentSlide, nextSlide) => {
          // $(".slick-slide", this).eq(currentSlide).addClass("prev-slide");
          // $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
          $(".slick-slide").eq(currentSlide).addClass("prev-slide");
          $(".slick-slide").eq(nextSlide).addClass("slide-animation");
        },
        afterChange: () => {
          // $(".prev-slide", this).removeClass("prev-slide slide-animation");
          $(".prev-slide").removeClass("prev-slide slide-animation");
        },
      });
    $slide.find(".slick-slide").eq(0).addClass("slide-animation");
  }
}

export default Hero;
